import { render, staticRenderFns } from "./HandlersWrapperButton.vue?vue&type=template&id=6a9a3370&scoped=true&"
import script from "./HandlersWrapperButton.vue?vue&type=script&lang=js&"
export * from "./HandlersWrapperButton.vue?vue&type=script&lang=js&"
import style0 from "./HandlersWrapperButton.vue?vue&type=style&index=0&id=6a9a3370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9a3370",
  null
  
)

export default component.exports